interface AccountingAccount {
  id?: number;
  codeIdentifier?: string;
  codeEnding?: string;
  name?: string;
  cashRegisterAccount?: boolean;
  inventoryAccount?: boolean;
  clientsAccount?: boolean;
  supplierAccount?: boolean;
  salesAccount?: boolean;
  productionCostAccount?: boolean;
  taxPayerId?: number;
  accountType?: string;
  parentId?: number;
  clientId?: number;
  supplierId?: number;
  locked?: boolean;
}

export const newAccountingAccount = (): AccountingAccount => {
  return {};
};
export default AccountingAccount;
